import request from '@/utils/request'
import { getRefreshToken } from '@/utils/auth'
import service from '@/utils/request'

// 登录方法
export function login(account, password, captchaVerification) {
  const data = {
    account,
    password,
    captchaVerification
  }
  return request({
    url: '/com/shop/auth/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/com/shop/auth/get-permission-info',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/com/shop/auth/logout',
    method: 'post'
  })
}


// 获得店铺信息
export function getMyShopInformation(id) {
  return request({
    url: '/com/shop/member/get?id='+id,
    method: 'get'
  })
}



// 获取登录验证码
export function sendSmsCode(mobile, scene) {
  return request({
    url: '/system/auth/send-sms-code',
    method: 'post',
    data: {
      mobile,
      scene
    }
  })
}


// 刷新访问令牌
export function refreshToken() {
  return service({
    url: '/com/shop/auth/refresh-token?refreshToken=' + getRefreshToken(),
    method: 'post'
  })
}


